var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#007AFF",
  d: "M16.197 2H7.813C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.171 22 7.813 22h8.374C19.83 22 22 19.83 22 16.19V7.81C22.01 4.17 19.839 2 16.197 2m.59 7.7-5.672 5.67a.75.75 0 0 1-1.061 0l-2.831-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.301 2.3 5.143-5.14c.29-.29.77-.29 1.06 0s.29.76 0 1.06"
})));
export default SvgCheckboxActive;